import { Component } from '@theme/component';

const STORAGE_KEY = 'eme_announcement_dismissed';
const FOCUSABLE = 'a[href], button:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';

class EmeAnnouncementDismiss extends Component {
  dismiss() {
    document.documentElement.setAttribute('data-eme-announcement-dismissed', '');
    this.#focusHeader();
    if (window.Shopify?.designMode) return;
    try {
      sessionStorage.setItem(STORAGE_KEY, '1');
    } catch {}
  }

  #focusHeader() {
    const header = document.querySelector('header-component');
    if (!header) return;
    for (const element of header.querySelectorAll(FOCUSABLE)) {
      if (!(element instanceof HTMLElement) || !element.checkVisibility({ visibilityProperty: true })) continue;
      element.focus();
      return;
    }
  }
}

if (!customElements.get('eme-announcement-dismiss')) {
  customElements.define('eme-announcement-dismiss', EmeAnnouncementDismiss);
}
